export const IMAGE_SIZE_MIN = 260;

export const IMAGES = {
  SELL_HERO: '/images/sell-hero.jpg',
  BUY_HERO: '/images/buy-hero.jpg',
  ABOUT_HERO: '/images/about-hero.jpg',
  CATEGORY_VILLA: '/images/category-villa.jpg',
  CATEGORY_APARTMENT: '/images/category-apartment.jpg',
  CATEGORY_TOWNHOUSE: '/images/category-townhouse.jpg',
  CATEGORY_PLOT: '/images/category-plot.jpg',
  CATEGORY_FARM: '/images/category-farm.jpg',
  CATEGORY_COTTAGE: '/images/category-cottage.jpg',
};
